import i18n from '@/plugins/i18n'

export default class InvalidCredentialsError extends Error {
  readonly message = i18n.t('errors.invalidCredentials') as string
}
